var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"simple-layout"},[_c('v-container',{class:{ 'pa-0': _vm.$vuetify.breakpoint.xsOnly },attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-center":_vm.$vuetify.breakpoint.smAndUp,"justify-center":""}},[_c('v-scale-transition',{attrs:{"mode":"out-in"}},[_c('router-view',{ref:"view"})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }